import React from "react"
import { SUPPORT_POLICY } from "../../constants"

export default () => (
  <div data-testid="support-policy">
    <div className="legal-component">
      <p className="privacy-policy-content-title">{SUPPORT_POLICY}</p>
      <h5 className="privacy-policy-content-title">
        Technical recommendations
      </h5>
      <p className="privacy-policy-content-text">
        Supported web browsers include:
      </p>
      <ul className="privacy-policy-content-text">
        <li className="privacy-policy-content-text">Google Chrome</li>
        <li className="privacy-policy-content-text">Safari</li>
        <li className="privacy-policy-content-text">Firefox</li>
        <li className="privacy-policy-content-text">
          Microsoft Internet Explorer 11
        </li>
        <li className="privacy-policy-content-text">Microsoft Edge</li>
        <li className="privacy-policy-content-text">
          Other browsers may be used but Kaizen reserves discretion not to
          remedy browser specific issues with non-explicitly mentioned browsers
        </li>
      </ul>
      <h5 className="privacy-policy-content-title">Minimum hardware</h5>
      <p className="privacy-policy-content-text">
        Recommended using a 64 bit machine with a minimum of 4GB RAM
      </p>
      <p className="privacy-policy-content-text">
        Screen resolution: The minimum screen resolution supported is 1440 by
        900 pixels. &nbsp;Lower resolutions may result in restricted views of
        certain widgets, cropping or other issues which and all of those are
        outside of support when using a resolution lower than the minimum.
      </p>
      <h5 className="privacy-policy-content-title">
        Service Levels: Availability
      </h5>
      <p className="privacy-policy-content-text">
        The Hub will be provided from secure data centre(s) with:
      </p>
      <ul className="privacy-policy-content-text">
        <li className="privacy-policy-content-text">a 99% Availability; and</li>
        <li className="privacy-policy-content-text">
          served with at least 2Mb/s download speed and 1Mb/s upload speed
          internet connectivity, measured from the public facing router(s) at
          the data centre hosting the Hub.
        </li>
      </ul>
      <p className="privacy-policy-content-text">
        In the event that there is a Service Interruption, Kaizen shall:
      </p>
      <ul className="privacy-policy-content-text">
        <li className="privacy-policy-content-text">
          investigate the underlying causes of the Service Interruption and
          preserve any data indicating the cause of the Service Level Failure
          within 12 working hours of it being brought to the attention of
          Kaizen;
        </li>
        <li className="privacy-policy-content-text">
          take action such as may be necessary to minimise the impact of the
          Service Interruption to prevent it from recurring;
        </li>
        <li className="privacy-policy-content-text">
          correct the Service Interruption and resume performance in accordance
          with service level as soon as is reasonably practicable;
        </li>
        <li className="privacy-policy-content-text">
          advise the Client of the status of any remedial efforts being
          undertaken as may be reasonable in the circumstances.
        </li>
      </ul>
      <p className="privacy-policy-content-text">Service Exclusions</p>
      <ul className="privacy-policy-content-text">
        <li className="privacy-policy-content-text">
          These Service Levels shall not apply while any sum is outstanding to
          Kaizen under this Agreement or during a Service Interruption.
        </li>
        <li className="privacy-policy-content-text">
          The remedies stated here are the sole and exclusive remedies for
          breach of the Services Levels.
        </li>
      </ul>
      <h5 className="privacy-policy-content-title">Definitions</h5>
      <ul className="privacy-policy-content-text">
        <li className="privacy-policy-content-text">
          &ldquo;Availability&rdquo; means the time available in minutes each
          calendar month less Service Interruptions
        </li>
        <li className="privacy-policy-content-text">
          &ldquo;Incident&rdquo; means an event which qualifies for support
          reported by You to Kaizen.
        </li>
        <li className="privacy-policy-content-text">
          &ldquo;Response Time&rdquo; means the time interval between the first
          report by You of an Incident and the first intervention by
          Kaizen.&nbsp;
        </li>
        <li className="privacy-policy-content-text">
          &ldquo;Resolution Time&rdquo; means the time interval between Kaizen
          first starting to resolve the Incident, whether remotely or at the
          site address, and the final resolution of the incident.
        </li>
        <li className="privacy-policy-content-text">
          &ldquo;Service Interruption&rdquo; includes:
          <ul>
            <li className="privacy-policy-content-text">
              scheduled downtime for maintenance, upgrades and updates;&nbsp;
            </li>
            <li className="privacy-policy-content-text">
              dealing with malware attacks, including Denial of Service Attacks;
              and
            </li>
            <li className="privacy-policy-content-text">
              interruptions or interference with the Hub caused by any
              Qualification or Limitation in this Agreement;
            </li>
            <li className="privacy-policy-content-text">
              failures of network / equipment / circuits not owned, controlled
              or operated by Kaizen;
            </li>
            <li className="privacy-policy-content-text">
              failures of communications, internet connectivity and/or circuits
              external to the data centre(s) at which the Hub is hosted;
            </li>
            <li className="privacy-policy-content-text">
              technical faults in the network;
            </li>
            <li className="privacy-policy-content-text">
              faults caused by Abnormal Use of the Hub;
            </li>
            <li className="privacy-policy-content-text">Force Majeure;</li>
            <li className="privacy-policy-content-text">
              End User error or misunderstanding;
            </li>
            <li className="privacy-policy-content-text">
              acts or omissions of You and/or its Personnel which amounts to a
              breach of this Agreement and events flowing therefrom;
            </li>
            <li className="privacy-policy-content-text">
              any other event outside the control of Kaizen, howsoever caused or
              encountered.
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
)
